export const teams = [
  {
    id: 'team-001',
    name: 'Equipo Mañana',
    members: [
      { userId: 'user-001', role: 'Cuidador Principal' },
      { userId: 'user-002', role: 'Asistente' }
    ],
    schedule: 'L-V 7:00 AM - 3:00 PM'
  },
  {
    id: 'team-002',
    name: 'Equipo Tarde',
    members: [
      { userId: 'user-003', role: 'Cuidador Principal' },
      { userId: 'user-004', role: 'Asistente' }
    ],
    schedule: 'L-V 2:00 PM - 10:00 PM'
  }
];

export const users = [
  { id: 'user-001', name: 'Ana Cuidadora', email: 'ana@mascotel.com', phone: '3101234567' },
  { id: 'user-002', name: 'Carlos Asistente', email: 'carlos@mascotel.com', phone: '3102345678' },
  { id: 'user-003', name: 'Luisa Cuidadora', email: 'luisa@mascotel.com', phone: '3103456789' },
  { id: 'user-004', name: 'Pedro Asistente', email: 'pedro@mascotel.com', phone: '3104567890' }
];